import React from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../../helpers/t';

export function ListingTitle() {
  const listing = useSelector((state) => state.listing);

  return (
    (!listing.open_drafts || listing.open_drafts.length === 0 || !listing.open_drafts[0].title)
      ? <h1 className="title text-2xl md:text-3xl font-medium m-0 text-neutral-900" itemProp="name">{listing.title}</h1>
      : (
        <>
          <div data-ng-class="{'border-solid border-0 border-l-4 border-red-700 pl-2 line-through': viewingDraft}">
            <h1 className=" title text-2xl md:text-3xl font-medium my-1 text-neutral-900" itemProp="name">{listing.title}</h1>
          </div>
          <div data-ng-class="{'border-solid border-0 border-l-4 border-emerald-700 pl-2': viewingDraft}" data-ng-show="viewingDraft">
            <h1 className="title text-2xl md:text-3xl font-medium my-1 text-neutral-900">{listing.open_drafts[0].title}</h1>
          </div>
        </>
      )
  );
}

export function ListingSEOTitle() {
  const { _meta, neighborhood, city, location_type } = useSelector((state) => state.listing);
  const { userLanguage } = useSelector((state) => state.env) || {};
  const lang = userLanguage || 'en';

  const locationType = location_type.name === 'Partial' ? 'Partial' : 'Entire';
  let area = neighborhood ? `${neighborhood}, ${city}` : _meta.locationName;

  if (_meta.breadcrumbs.length > 0) {
    area = (lang === 'en' || !lang)
      ? _meta.breadcrumbs[_meta.breadcrumbs.length - 1].name
      : _meta.breadcrumbs[_meta.breadcrumbs.length - 1].translatedName.fr;
  }

  return (
    <h1
      dangerouslySetInnerHTML={{ __html: t(`listings.show.breadcrumbs.useCases.${_meta.primaryUseCase.slug}.seoTitle.${locationType}`, { area }) }}
      className="title text-xl font-normal my-0 text-neutral-900 md:font-medium md:text-2xl"
      itemProp="name"
    />
  );
}
